import { DeskAreaType, DeskAreaViewType } from "types";

const viewToTypes: Record<DeskAreaViewType, DeskAreaType[]> = {
  [DeskAreaViewType.All]: [DeskAreaType.FlexDesk, DeskAreaType.MeetingRoom, DeskAreaType.Parking, DeskAreaType.Other],
  [DeskAreaViewType.FlexDesk]: [DeskAreaType.FlexDesk],
  [DeskAreaViewType.MeetingRoom]: [DeskAreaType.MeetingRoom],
  [DeskAreaViewType.Parking]: [DeskAreaType.Parking],
  [DeskAreaViewType.Other]: [DeskAreaType.Other],
};

export const deskAreasForViewType = (deskArea: DeskAreaViewType): DeskAreaType[] => viewToTypes[deskArea];
